import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=25f94f22&scoped=true"
import script from "./Development.vue?vue&type=script&lang=js"
export * from "./Development.vue?vue&type=script&lang=js"
import style0 from "./Development.vue?vue&type=style&index=0&id=25f94f22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f94f22",
  null
  
)

export default component.exports